import { render, staticRenderFns } from "./HiringsForm.vue?vue&type=template&id=0650f33d&xmlns%3A=true"
import script from "./HiringsForm.vue?vue&type=script&lang=js"
export * from "./HiringsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports